import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function OpenButton({ className }: Props) {
  return (
    <svg
      className={classNames(className, styles.openButton)}
      viewBox="0 0 27.007 23.619"
    >
      <g transform="translate(-283.249 -29.817)">
        <path
          className="arrow"
          d="M15.321,18l8.937-8.93a1.688,1.688,0,0,0-2.391-2.384L11.742,16.8a1.685,1.685,0,0,0-.049,2.327L21.86,29.32a1.688,1.688,0,0,0,2.391-2.384Z"
          transform="translate(271.998 23.623)"
        />
        <path
          className="arrow"
          d="M15.321,18l8.937-8.93a1.688,1.688,0,0,0-2.391-2.384L11.742,16.8a1.685,1.685,0,0,0-.049,2.327L21.86,29.32a1.688,1.688,0,0,0,2.391-2.384Z"
          transform="translate(285.502 23.623)"
        />
      </g>
    </svg>
  );
}

export { OpenButton };
